import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  fixtureMatchSchema,
  fixtureMatchListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/fixtureMatches/actions';
import { FixtureMatchesActionTypes as types } from 'app/ducks/fixtureMatches/types';

function* createFixtureMatchesaga(action): any {
  yield put(sagaActions.createFixtureMatchPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).fixtureMatches.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);

    yield put(sagaActions.createFixtureMatchesuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createFixtureMatchFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateFixtureMatchesaga(action): any {
  yield put(sagaActions.updateFixtureMatchPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).fixtureMatches.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);

    yield put(sagaActions.updateFixtureMatchesuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateFixtureMatchFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getFixtureMatchSaga(action): any {
  yield put(sagaActions.getFixtureMatchPending());
  const [error, response] = yield (yield TeammoApi(yield select())).fixtureMatches.show(
    action.payload.id,
    null,
    action.payload.eventDashboardId,
  );
  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);
    yield put(sagaActions.getFixtureMatchesuccess(normalizedResponse));
    return normalizedResponse.entities.fixtureMatches[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getFixtureMatchFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    ),
  );
  return null;
}

function* getAllFixtureMatchesSaga(action): any {
  yield put(
    sagaActions.getAllFixtureMatchesPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  let paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.fixtureMatches.pagination),
    )
    : action.payload.pagination;

  paginationObject = { ...paginationObject, page: { size: 200 } };

  const [error, response] = yield (yield TeammoApi(yield select())).fixtureMatches.list(
    paginationObject,
    action.payload.eventDashboardId,
  );

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchListSchema);
    yield put(
      sagaActions.getAllFixtureMatchesSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllFixtureMatchesFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createFixtureMatchesagaWatcher(): any {
  yield takeEvery(
    types.CREATE_FIXTURE_MATCH_REQUESTED,
    createFixtureMatchesaga,
  );
}

function* updateFixtureMatchesagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_FIXTURE_MATCH_REQUESTED,
    updateFixtureMatchesaga,
  );
}

function* getFixtureMatchSagaWatcher(): any {
  yield takeLatest(types.GET_FIXTURE_MATCH_REQUESTED, getFixtureMatchSaga);
}

function* getAllFixtureMatchesSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_FIXTURE_MATCHS_REQUESTED,
    getAllFixtureMatchesSaga,
  );
}

export default function* root(): any {
  yield all([
    createFixtureMatchesagaWatcher(),
    updateFixtureMatchesagaWatcher(),
    getFixtureMatchSagaWatcher(),
    getAllFixtureMatchesSagaWatcher(),
  ]);
}
